export default __webpack_public_path__ + "static/media/client-16.41f53707.png";